/**
 * Dependency-free registration-scoping helpers (B6). Kept out of the
 * Angular/Capacitor-heavy `opsctrl-foc/functions.ts` so the out-of-tree
 * better-sqlite3 smoke can import the real logic (same split as `db/rowid.ts`).
 */

/**
 * Every opsctrl table that carries a `registrationId` column (added by the
 * Phase-A migration). Single source of truth for both the boot migration
 * (`runRegistrationMigrationScripts`) and the B6 login-time legacy-device →
 * real-reg re-tag.
 */
export const OPS_REG_MIGRATION_TABLES = [
  "opsctrl_flightopscontroller_flightlist",
  "opsctrl_flightopscontroller_flightcrew",
  "opsctrl_flightopscontroller_param",
  "opsctrl_flightopscontroller_fuel",
  "opsctrl_flightopscontroller_loading",
  "opsctrl_flightopscontroller_loadingelements",
  "opsctrl_flightopscontroller_nav",
  "opsctrl_flightopscontroller_navseg",
  "opsctrl_flightopscontroller_notam",
  "opsctrl_flightopscontroller_met",
  "opsctrl_flightopscontroller_perf",
  // flightcrewcontroller tables — catalog reads (e.g. dutyActiveAtTimeForAircraft)
  // are scoped: 'registration', so these need the registrationId column too,
  // otherwise the scoped SQL fails on native with `no such column`.
  "opsctrl_flightcrewcontroller_duties",
  "opsctrl_flightcrewcontroller_crewmemberdata",
  "opsctrl_flightcrewcontroller_historiccrewmembers",
];

/** The migration's single-tenant placeholder, replaced by the real reg on adopt. */
export const LEGACY_DEVICE_ID = "legacy-device";

/**
 * B6 login-time re-tag: move every `legacy-device`-tagged row to the device's
 * real registration (aircraft tail). A device is lifetime-bound to one aircraft,
 * so all its `legacy-device` history belongs to that single reg. The statements
 * are parameterized (`?` = the reg) — bound by the caller, never interpolated —
 * and idempotent: after the first adopt no `legacy-device` rows remain, so
 * subsequent runs match nothing.
 */
export function retagLegacyDeviceScripts(): string[] {
  return OPS_REG_MIGRATION_TABLES.map(
    (tbl) => `UPDATE \`${tbl}\` SET \`registrationId\` = ? WHERE \`registrationId\` = '${LEGACY_DEVICE_ID}';`
  );
}
